import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export type BaseEmptyPageProps = {
  /** The page's content */
  children?: React.ReactNode;
  /** Padding multiplier to use on the content */
  padding?: number;
};

type StyleProps = {
  padding: number;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      flexGrow: 1,
      padding: (props: StyleProps): number => theme.spacing(props.padding),
    },
  }),
);

const BaseEmptyPage = ({
  children,
  padding = 2,
}: BaseEmptyPageProps): JSX.Element => {
  const classes = useStyles({ padding });
  return <div className={classes.content}>{children}</div>;
};

export default BaseEmptyPage;
